import { Button } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { SupportArticleLinks } from "@src/appV2/support/constants";

export function UndeterminedShiftButton() {
  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.TAPPED_CONTACT_SUPPORT_FOR_UNDETERMINED_BOOKABILITY_STATUS);
        window.open(SupportArticleLinks.HOW_TO_CONTACT_SUPPORT, "_blank");
      }}
    >
      <b>Contact Support</b>
    </Button>
  );
}
